var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import Card from "@irati/ui/src/Layout/Card";
import { H2, H4 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import AccountRewardsQuery from "@irati/reward/apollo/query/AccountRewards";
import Loader from "@irati/utils/services/apollo/Loading/Loader";
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom";
import authentication from "@irati/auth";
import EmptyRewards from "@irati-web/reward/src/components/MyRewards/EmptyRewards";
import MyRewardsList from "@irati-web/reward/src/components/MyRewards/MyRewardsList";
import MyRewardPopup from "@irati-web/reward/src/components/MyRewards/MyRewardsPopup/MyRewardPopup";
import LoadMore from "../../../components/LoadMore";
var Rewards = /** @class */ (function (_super) {
    __extends(Rewards, _super);
    function Rewards() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedRedemption: undefined,
            hasRefetchingError: false
        };
        _this.onLoadMore = null;
        _this.handleScroll = function () {
            var atBottom = scrollAtBottom();
            var hasRefetchingError = _this.state.hasRefetchingError;
            if (atBottom && !hasRefetchingError && _this.onLoadMore) {
                _this.fetchMore();
            }
        };
        _this.openPopUp = function (selectedRedemption) {
            _this.setState({ selectedRedemption: selectedRedemption });
        };
        _this.closePopUp = function () {
            _this.setState({ selectedRedemption: undefined });
        };
        _this.fetchMore = function () {
            _this.setState({
                hasRefetchingError: false
            });
            _this.onLoadMore().catch(function () {
                _this.setState({
                    hasRefetchingError: true
                });
            });
        };
        return _this;
    }
    Rewards.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.handleScroll);
    };
    Rewards.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.handleScroll);
    };
    Rewards.prototype.hasReceivedData = function (data) {
        return data && "rewardRedemptions" in data && "results" in data.rewardRedemptions && data.rewardRedemptions.results.length > 0;
    };
    Rewards.prototype.hasMoreData = function (data) {
        return !!get(data, "rewardRedemptions.hasMore", false);
    };
    Rewards.prototype.render = function () {
        var _this = this;
        var _a = authentication.user(), uuid = _a.uuid, businessId = _a.businessId;
        var variables = {
            tenantId: businessId,
            userId: uuid,
            limit: 5
        };
        var _b = this.state, selectedRedemption = _b.selectedRedemption, hasRefetchingError = _b.hasRefetchingError;
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, { tiny: true, noBorder: true },
                React.createElement(H2, { base: true },
                    React.createElement(FormattedMessage, { id: "recognition.account.rewards.header" })),
                React.createElement(H4, { base: true },
                    React.createElement(FormattedMessage, { id: "recognition.account.rewards.desc" })),
                React.createElement(AccountRewardsQuery, { variables: variables }, function (_a) {
                    var data = _a.data, refetch = _a.refetch, fetchMore = _a.fetchMore, isLoading = _a.loading, error = _a.error, networkStatus = _a.networkStatus;
                    var hasData = _this.hasReceivedData(data);
                    var hasMore = _this.hasMoreData(data);
                    var isRefetching = networkStatus === 3;
                    var hasError = error || hasRefetchingError;
                    _this.onLoadMore = !isLoading && hasMore ? function () { return fetchMore(variables); } : null;
                    return isLoading && !isRefetching ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null,
                        hasData && React.createElement(MyRewardsList, { openPopUp: _this.openPopUp, redemptions: data.rewardRedemptions.results }),
                        isLoading && React.createElement(Loader, null),
                        !isLoading && hasError && React.createElement(LoadMore, { onClick: error ? function () { return refetch(); } : _this.fetchMore }),
                        !isLoading && !hasError && !hasData && React.createElement(EmptyRewards, null)));
                })),
            React.createElement(MyRewardPopup, { onHide: this.closePopUp, show: !!selectedRedemption, redemption: selectedRedemption })));
    };
    return Rewards;
}(PureComponent));
export default Rewards;
